<template>
  <v-row justify="center">
    <v-dialog v-model="isOn" width="800">
      <v-card>
        <v-card-title class="text-h4 font-weight-bold primary--text">
          {{ value.name }}
        </v-card-title>
        <v-card-text>
          <div class="mb-2 body-1">
            <span class="font-weight-bold">Description: </span
            >{{ value.description }}
          </div>
          <div class="mb-2 body-1">
            <span class="font-weight-bold">Code: </span>{{ value.code }}
          </div>
          <div class="mb-2 body-1">
            <span class="font-weight-bold">Uses: </span>{{ value.uses }}
          </div>
          <div class="mb-2 body-1">
            <span class="font-weight-bold">Active: </span>{{ value.isActive }}
          </div>
          <div class="mb-2 body-1">
            <span class="font-weight-bold">Discount: </span>
            {{
              value.discount.isAvailable
                ? value.discount.amount +
                  (value.discount.type === "Percentage" ? "%" : "")
                : "Not available"
            }}
          </div>
          <div class="mb-2 body-1" v-if="value.requirements.isAvailable">
            <span class="font-weight-bold">Requirements: </span>
            <ul>
              <li v-for="(value, key) in value.requirements" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </div>
          <div class="mb-2 body-1" v-if="value.recurring.isAvailable">
            <span class="font-weight-bold">Recurring: </span>
            <ul>
              <span class="font-weight-bold">Discount:</span>
              {{
                !value.recurring.discount && value.recurring.discountisAvailable
                  ? value.recurring.discount.amount +
                    (value.recurring.discount.type === "Percentage" ? "%" : "")
                  : "Not available"
              }}
              <br />
              <li class="font-weight-bold">Free Trials:</li>
              <ul>
                <li
                  v-for="(item, index) in value.recurring.freeTrials"
                  :key="index"
                >
                  {{ item.frequency }}: {{ item.period }}
                </li>
              </ul>
            </ul>
          </div>
          <div class="mb-2 body-1">
            <span class="font-weight-bold">Created By: </span
            >{{ value.createdBy }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            variant="text"
            @click="$emit('promoCodePopupOff')"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "PromoCodePopup",
  props: {
    isOn: { type: Boolean, required: true, default: false },
    value: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
}
</style>
